import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { IdName } from 'src/app/shared/models/id-name.model';
import { FormActionBtn } from 'src/app/shared/enums/form-action-btn.enum';

@Pipe({
  name: 'formActionBtn',
  standalone: false
})
export class FormActionBtnPipe implements PipeTransform {
  public transform(value: FormActionBtn): string {
    return getFormActionBtn(value);
  }
}

export function getFormActionBtn(value: FormActionBtn): string {
  switch (value) {
    case FormActionBtn.Delete:
      return 'Delete';
    case FormActionBtn.Override:
      return 'Override';
    case FormActionBtn.Reject:
      return 'Reject';
    case FormActionBtn.View:
      return 'View';
    case FormActionBtn.Retake:
      return 'Retake';
    case FormActionBtn.Print:
      return 'Print';
    default:
      throw new Error(`Unsupported value for FormActionBtn: ${value}.`);
  }
}

export function getFormActionBtnList(): IdName[] {
  return enumToList(FormActionBtn, getFormActionBtn);
}
